import { BaseResponse, MessageResponse } from 'common/types/api'
import axios from 'core/api'
import { SendOTPBody, VerifyOTPBody, VerifyOTPResponse } from 'modules/auth/api/types'

import { buildUrlWithParams } from 'utils/url'

import {
  ChangePhoneNumberRequest,
  EditUserInfoRequest,
  FarmNotification,
  FeedbackRequest,
  NotificationPagination,
  UnreadNotification,
  UserInfoResponse,
} from './types'

export const getUserInfo = () => axios.get<BaseResponse<UserInfoResponse>>('/user')

export const editUserInfo = (body: EditUserInfoRequest) =>
  axios.patch<MessageResponse>('/user', body)

export const uploadProfilePicture = (data: FormData) =>
  axios.post<BaseResponse<string>>('/user/profile-image', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

export const createFeedback = (body: FeedbackRequest) =>
  axios.post<MessageResponse>('/user/feedback', body)

export const sendOTPChangePhone = (body: SendOTPBody) =>
  axios.post<MessageResponse>('/phone-number/send-sms-otp', body)

export const verifyOTPChangePhone = (body: VerifyOTPBody) =>
  axios.post<BaseResponse<VerifyOTPResponse>>('/phone-number/verify-sms-otp', body)

export const changePhoneNumber = (body: ChangePhoneNumberRequest) =>
  axios.patch<MessageResponse>('/phone-number', body)

export const getFarmNotifications = () =>
  axios.get<BaseResponse<FarmNotification[]>>('/notification/farms')

export const getNotificationList = (params: { farmId: string; pageSize: number; page: number }) =>
  axios.get<BaseResponse<NotificationPagination>>(
    buildUrlWithParams(`notification/farms/${params.farmId}`, {
      page: params.page,
      pageSize: params.pageSize,
    })
  )

export const getTotalUnreadNotification = () =>
  axios.get<BaseResponse<UnreadNotification>>('/notification/unread/count')
export const updateReadAt = (notificationIds: string[]) =>
  axios.patch('/notification/bulk/read', { ids: notificationIds })
export const deleteNotification = (notificationId: string) =>
  axios.delete(`/notification/${notificationId}`)
export const deleteAllNotification = (farmId: string) => axios.delete(`/notification/farms/${farmId}`)